export default __webpack_public_path__ + "static/media/dinner.d5556531.jpg";